/** An API error: the API client (api/client.ts) keeps the response body. */
export type ApiError = Error & { responseBody?: string };

/**
 * Converts an unknown thrown value into a safe, user-facing message.
 *
 * The API client keeps the response body on the error as ``responseBody``
 * (ky's own message is only the status line). We parse it to extract the
 * sanitised message from the backend's JSON shape (either the B-9 global
 * handler format or FastAPI's native detail format), and fall back to a
 * generic string so internal details never reach the UI.
 */
export function toUserMessage(error: unknown): string {
  if (!(error instanceof Error)) return "An error occurred.";
  try {
    const body = JSON.parse((error as ApiError).responseBody ?? error.message);
    // Shape from B-9 global exception handler: { error: { message: string } }
    if (typeof body?.error?.message === "string") return body.error.message;
    // FastAPI native shape: { detail: string }
    if (typeof body?.detail === "string") return body.detail;
  } catch {
    // error.message is a plain string, not JSON — use the generic fallback
  }
  return "An error occurred. Please try again.";
}
